import styled, { css, DefaultTheme, Interpolation, ThemeProps } from 'styled-components';
import { stylePerBreakpoint } from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Divider } from '../Divider/SimpleDivider/styles';
import { Grid, GridItem } from '../Grid';
import Pagination from '../Pagination';

export type BottomMargin = Partial<{
  desktop: number;
  tabletPortrait: number;
  tabletLandscape: number;
  mobile: number;
}>;

const processCustomBottomSpace = (
  customBottomSpacing?: BottomMargin
): Interpolation<ThemeProps<DefaultTheme>> =>
  stylePerBreakpoint(
    (breakpoint) =>
      customBottomSpacing?.[breakpoint] &&
      css`
        &&& {
          margin-bottom: ${spacing(customBottomSpacing[breakpoint])};
        }
      `
  );

export const ListWithPaginationGrid = styled(Grid)<{
  enforceBottomSpaceConsistency?: boolean;
  isListGreaterThanDisplayCount: boolean;
  customBottomSpacing?: BottomMargin;
}>`
  ${({
    enforceBottomSpaceConsistency,
    isListGreaterThanDisplayCount,
    customBottomSpacing,
  }) =>
    enforceBottomSpaceConsistency &&
    !isListGreaterThanDisplayCount &&
    (customBottomSpacing
      ? processCustomBottomSpace(customBottomSpacing)
      : css`
          margin-bottom: ${spacing(5)};
        `)}
`;

type ListWithPaginationGridItemProps = {
  displayDividers: boolean;
};

export const ListWithPaginationGridItem = styled(GridItem)<
  ListWithPaginationGridItemProps
>`
  display: flex;

  ${({ displayDividers }) => css`
    flex-direction: ${displayDividers ? 'column' : 'row'};
  `}
`;

export const ListWithPaginationWrapper = styled.div``;

export const PaginationButtons = styled(Pagination)<{
  customBottomSpacing?: BottomMargin;
}>`
  ${({ customBottomSpacing }) => processCustomBottomSpace(customBottomSpacing)}
`;

export const PaginationDivider = styled(Divider)``;

export const ChildWrapper = styled.div<ListWithPaginationGridItemProps>`
  width: 100%;
  display: flex;
  ${({ displayDividers }) =>
    displayDividers &&
    css`
      padding-top: ${spacing(4)};
      padding-bottom: ${spacing(4)};
    `}

  /* Make child full width */
  > * {
    width: 100%;
  }
`;
